import { IKeyValue } from "motw_core/Entity/IKeyValue";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import Player from "source/app/domain/Player";
import { GetDefaultKeyValue } from "source/app/infrastructure/Data/KeyValues/defaultKeyValue";
import { ChangeCICOValue } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/CICO/Helpers/ChangeCICOValue";
import { TodaysValueWithHistory } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/CICO/Helpers/TodaysValueWithHistory";
import { MathUtils } from "source/app/services/Math/MathUtils";
import { ShareState } from "source/app/services/UI/State/ShareState";
import { ResetCICOValue } from "../Helpers/ResetCICOValue";

export function CICOCalories({
    timeCompletePercent,
}: {
    timeCompletePercent: number;
}) {
    const [keyValue, setKeyValue] = React.useState<IKeyValue>(
        GetDefaultKeyValue()
    );

    const [increaseBy, setIncreaseBy] = React.useState<number>(0);

    ShareState(ESharedFunction.CICO_calories, keyValue, setKeyValue);

    const todaysCaloriesRecorded =
        keyValue.value === GetDefaultKeyValue().value
            ? 0
            : Number.parseInt(keyValue.value);

    const todaysCalories =
        todaysCaloriesRecorded + MathUtils.IfIsNaN(increaseBy, 0);

    const caloriesPercent = Math.floor(
        (todaysCalories / Player.maxCalories) * 100
    );

    const caloriesRemaining = Math.floor(
        (timeCompletePercent / 100) * Player.maxCalories - todaysCalories
    );

    const caloriesRemainingText =
        caloriesRemaining > 0 ? `| +${caloriesRemaining}` : ``;

    const delta = timeCompletePercent - caloriesPercent;
    const deltaText = (delta >= 0 ? `+` : ``) + delta;

    return (
        <div
            style={{
                textAlign: "center",
                margin: "10px",
                borderRadius: "6px",
                background: "rgb(0 0 0 / 15%)",
                padding: "10px",
                flexGrow: 1,
            }}
        >
            <div>
                Calories:
                <span style={{ margin: `0px 5px` }}>
                    <TodaysValueWithHistory
                        {...{
                            todaysValue: todaysCalories,
                            keyValue,
                            sharedFunction: ESharedFunction.CICO_calories,
                        }}
                    />
                </span>
                | {caloriesPercent}% {caloriesRemainingText}
                <ResetCICOValue
                    {...{
                        sharedFunction: ESharedFunction.CICO_calories,
                        keyValue,
                    }}
                />
            </div>
            <div
                style={{
                    fontSize: "22px",
                    fontWeight: "bold",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                    }}
                >
                    <span style={{ flexBasis: `200px` }}>
                        Calories
                        <span
                            style={{
                                marginLeft: `10px`,
                                color:
                                    delta > 0 ? `rgb(142 203 17)` : `inherit`,
                            }}
                        >
                            {deltaText}%
                        </span>
                    </span>
                </div>
            </div>
            <ChangeCICOValue
                {...{
                    increaseBy,
                    setIncreaseBy,
                    sharedFunction: ESharedFunction.CICO_calories,
                    keyValue
                }}
            />
        </div>
    );
}
